import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Avatar from '@material-ui/core/Avatar';
import deepOrange from '@material-ui/core/colors/deepOrange';
import * as actions from '@lesofi/phoenix-sdk-js/lib/admin/redux/topnav/actions'

class CustomHeader extends Component {
  logout() {
    this.props.logout();
  }

  UNSAFE_componentWillUpdate(){
     const x = document.getElementById("myTopnav");
     if (x.className.indexOf('responsive')>0){
        x.className = "topnav";
     }
  }

  menuClick(e){
    e.preventDefault();
    const x = document.getElementById("myTopnav");
    if (x.className === "topnav") {
        x.className += " responsive";
    } else {
        x.className = "topnav";
    }
  }

  renderAvatar(){
    const { imageUrl,name } = this.props.profile; 
    if (imageUrl){
      return <Avatar src={imageUrl} />
    }else {
      const avatarName=name.substring(0, 2).toUpperCase();
      return <Avatar style={{margin: 0,color: '#fff',backgroundColor: deepOrange[500]}}>{avatarName}</Avatar>
    }
  }

  render() {
    const renderLogonComponent = () => {
      if (this.props.profile){
        //const { imageUrl,email } = this.props.profile;  

        return (
            <div className="avatarProfile dropdownMenu">
                <button className="dropbtn">{this.renderAvatar()}</button>
                <div className="dropdown-content">
                  <a href="#" className="profileLink" onClick={this.logout.bind(this)}>Logout</a>
                </div>
            </div>
          )
      }
    }

    return (
      <header className="app-header topnavBackground">
        <div className='container'>
          <div className="topnav" id="myTopnav">
                <Link to="/" className='logo active' >
                  Dashboard&nbsp;<span className="badge badge-pill badge-warning" style={{fontSize: '8px'}}>0.13.0</span>
                </Link>
                {renderLogonComponent()}
                <a style={{fontSize:'15px'}} className="icon" onClick={(e)=>this.menuClick(e)}>&#9776;</a>
          </div>
        </div>
       </header>
      )
    
  }
}

//export default Header;
const mapStateToProps = (state) => {
  return state;
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
      topnavUpdate: () => {
          dispatch(actions.topnavUpdate())
      },
  }
}

export default connect(mapStateToProps,mapDispatchToProps)(CustomHeader)


// WEBPACK FOOTER //
// ./src/components/CustomHeader/CustomHeader.js